import { render, staticRenderFns } from "./setKenaikanPangkat.vue?vue&type=template&id=2cce7685&"
import script from "./setKenaikanPangkat.vue?vue&type=script&lang=js&"
export * from "./setKenaikanPangkat.vue?vue&type=script&lang=js&"
import style0 from "./setKenaikanPangkat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports